import type { DomainMapper } from '../types';

// TODO: Backend team should create a dedicated applicationId for corporate domains.
// Currently reusing GB's applicationId (1161 stage / 1163 prod) to get translations
// from /applications/configuration. This also returns ecom data (filters, products)
// which we don't need — the dedicated applicationId should only return translations.
const corporateEn: DomainMapper = {
  countryCode: 'corporate-en',
  currency: 'GBP',
  domain: 'kahrs-preview.iveo.store',
  environment: 'preview',
  flagUrl: '/flags/GB-UKM.svg',
  languagePrimary: false,
  locale: 'en-GB',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  sitemapUrl: 'https://kahrs-api.test/storage/sitemaps/sitemap-uk.xml',
  storyblokBasePath: 'en',
  url: 'https://kahrs-preview.iveo.store/en',
  applicationId: 1163, //  reusing GB until dedicated corporate applicationId exists
  subFolder: true,
  googleSiteVerification: '_khK6fTW4MrMqgixPOHH37F9BD7VJNkk3JXdFUMZthA',
  bodyClass: 'corpSite',

  features: {
    fastOrder: false,
    backorders: false,
    cartSettings: false,
    nonEcomSite: true,
    cisionLanguage: 'en',
  },
} as DomainMapper;

export default corporateEn;
